import { queryOptions, useQuery } from '@tanstack/react-query';

import type { IHttpClient } from '../../api/client.js';
import { useHttpClient } from '../../api/HttpClientContext.js';
import {
  getServiceVersion,
  type ServiceVersion,
} from '../../services/serviceVersionService.js';

const serviceVersionKey = ['serviceVersion'] as const;

function serviceVersionQuery(client: IHttpClient) {
  return queryOptions({
    queryKey: serviceVersionKey,
    queryFn: (): Promise<ServiceVersion> => getServiceVersion(client),
    staleTime: Number.POSITIVE_INFINITY,
  });
}

export interface UseServiceVersionResult {
  data: ServiceVersion | undefined;
  isLoading: boolean;
  error: Error | null;
}

export function useServiceVersion(): UseServiceVersionResult {
  const client = useHttpClient();
  const query = useQuery(serviceVersionQuery(client));

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
